<template>
  <div class="container is-uppercase has-text-weight-bold">
    <Header/>
      <img v-if="$i18n.locale() === 'th'" src="@/../static/kfit/home_vid.png" class="image m-b-md">
      <div class="section">
        <table style="width:100%;">
          <tr>
            <td style="padding-right:5%;">
              <div class="box is-rounded has-text-left is-vertical-center shadow" style="height:8rem;width:100%;">
                <router-link :to="{ name: 'Training' }">
                  <p :class="$store.getters.isMH ? 'has-text-black' : 'has-text-white'">
                    {{ 'Days' | translate }}: <span class="has-text-primary">{{ days }}</span><br/>
                    {{ 'Streak' | translate }}: <span class="has-text-primary">{{ streak }}</span><br/>
                    {{ 'Points' | translate }}: <span class="has-text-primary">{{ points }}</span><br/>
                    {{ 'Finished Workouts' | translate }}: <span class="has-text-primary">{{ finished }}</span></p>
                </router-link>
              </div>
            </td>
            <td style="width:8rem">
              <div class="box is-rounded has-text-centered shadow p-l-none p-r-none" style="height:8rem;width:100%;">
                <router-link :to="{ name: 'EatingPlan' }">
                  <img v-if="$store.getters.isMH" src="@/../static/icons/food.png" style="width:4rem;">
                  <img v-else src="@/../static/food-kpf.svg" style="width:4rem;">
                  <p :class="'m-t-xs home-eating-plan ' + ($store.getters.isMH ? 'has-text-black' : 'has-text-white')">{{ 'Eating plan' | translate }}</p>
                </router-link>
              </div>
            </td>
          </tr>
        </table>
        <div class="m-b-lg m-t-md">
          <router-link :to="{ name: 'Training' }" class="m-t-md m-r-lg button has-background-primary is-size-5 has-text-white is-rounded" style="width: 20rem;">{{ 'Begin' | translate }}</router-link>
          <router-link v-if=" ! $store.getters.isMH || $i18n.locale() === 'gr' || $i18n.locale() === 'my'" :to="{ name: 'TrainingList' }" class="m-t-md button has-background-dark is-size-5 has-text-white is-rounded" style="min-width: 20rem;">{{ 'See more workouts' | translate }}...</router-link>
        </div>
        <ul class="steps is-vertical is-small">
          <li :class="'steps-segment' + (counter == 0 ? ' is-active' : ' has-text-grey')">
            <span :class="'steps-marker' + (counter == 0 ? '' : ' is-hollow')"></span>
            <div class="steps-content step-1">
              <p class="is-size-4 lh-1">1 {{ 'Day' | translate }}</p>
            </div>
            <div class="steps-content step-2">
              <router-link :to="{ name: 'Training' }" class="is-size-4 lh-1">{{ $t('W workouts with R repetitions', { W: 9, R: 5 }) }}</router-link>
            </div>
          </li>
          <li :class="'steps-segment' + (counter == 1 ? ' is-active' : ' has-text-grey')">
            <span :class="'steps-marker' + (counter == 1 ? '' : ' is-hollow')"></span>
            <div class="steps-content step-1">
              <p class="is-size-4 lh-1">2 {{ 'Day' | translate }}</p>
            </div>
            <div class="steps-content step-2">
              <router-link :to="{ name: 'Training' }" class="is-size-4 lh-1">{{ $t('W workouts with R repetitions', { W: 10, R: 5 }) }}</router-link>
            </div>
          </li>
          <li :class="'steps-segment' + (counter == 2 ? ' is-active' : ' has-text-grey')">
            <span :class="'steps-marker' + (counter == 2 ? '' : ' is-hollow')"></span>
            <div class="steps-content step-1">
              <p class="is-size-4 lh-1">3 {{ 'Day' | translate }}</p>
            </div>
            <div class="steps-content step-2">
              <router-link :to="{ name: 'Training' }" class="is-size-4 lh-1">{{ $t('W workouts with R repetitions', { W: 12, R: 5 }) }}</router-link>
            </div>
          </li>
          <li :class="'steps-segment' + (counter == 3 ? ' is-active' : ' has-text-grey')">
            <span :class="'steps-marker' + (counter == 3 ? '' : ' is-hollow')"></span>
            <div class="steps-content step-1">
              <p class="is-size-4 lh-1">4 {{ 'Day' | translate }}</p>
            </div>
            <div class="steps-content step-2">
              <p class="is-size-4 lh-1">{{ $t('Take a break') }}</p>
            </div>
          </li>
          <li :class="'steps-segment' + (counter == 4 ? ' is-active' : ' has-text-grey')">
            <span :class="'steps-marker' + (counter == 4 ? '' : ' is-hollow')"></span>
            <div class="steps-content step-1">
              <p class="is-size-4 lh-1">5 {{ 'Day' | translate }}</p>
            </div>
            <div class="steps-content step-2">
              <router-link :to="{ name: 'Training' }" class="is-size-4 lh-1">{{ $t('W workouts with R repetitions', { W: 9, R: 5 }) }}</router-link>
            </div>
          </li>
          <li :class="'steps-segment' + (counter == 5 ? ' is-active' : ' has-text-grey')">
            <span :class="'steps-marker' + (counter == 5 ? '' : ' is-hollow')"></span>
            <div class="steps-content step-1">
              <p class="is-size-4 lh-1">6 {{ 'Day' | translate }}</p>
            </div>
            <div class="steps-content step-2">
              <router-link :to="{ name: 'Training' }" class="is-size-4 lh-1">{{ $t('W workouts with R repetitions', { W: 10, R: 5 }) }}</router-link>
            </div>
          </li>
          <li :class="'steps-segment' + (counter == 6 ? ' is-active' : ' has-text-grey')">
            <span :class="'steps-marker' + (counter == 6 ? '' : ' is-hollow')"></span>
            <div class="steps-content step-1">
              <p class="is-size-4 lh-1">7 {{ 'Day' | translate }}</p>
            </div>
            <div class="steps-content step-2">
              <router-link :to="{ name: 'Training' }" class="is-size-4 lh-1">{{ $t('W workouts with R repetitions', { W: 12, R: 5 }) }}</router-link>
            </div>
          </li>
        </ul>
        <br>
      </div>
    
    <br v-if="$i18n.locale() === 'gr'" class="m-b-xl">
    <div v-if="$i18n.locale() === 'gr'" class="has-background-dark" style="position:fixed;left:0;right:0;bottom:0;">
        <router-link :to="{ name: 'Training' }" class="is-fullwidth has-background-primary has-text-white has-text-centered is-block p-sm is-size-3">
          <span>{{ $t('Start training') }}! </span>
          <img src="@/../static/svg/play.svg" class="icon" style="height: 3rem;width: 3rem;margin-bottom:-0.75rem !important">
        </router-link>
      <Footer />
    </div>
    <Footer v-else/>
  </div>
</template>

<script>
import axios from 'axios'
import Header from '@/components/Header'
import Footer from '@/components/Footer'


export default {
  name: 'Home',
  data () {
    let todayTxt = this.$i18n.translate('Take a break')
    if (this.$store.getters.getTrainingDays % 4 < 2) {
      todayTxt = this.$i18n.translate('W workouts with R repetitions', { W: 5, R: 5 })
    } else if (this.$store.getters.getTrainingDays % 4 === 2) {
      todayTxt = this.$i18n.translate('S km stretch', { S: 3 })
    }
    return {
      todayTxt,
      counter: this.$store.getters.getTrainingDays % 4,
      days: this.$store.getters.getTrainingDays,
      streak: this.$store.getters.getTrainingDays,
      points: this.$store.getters.getTrainingDays,
      finished: this.$store.getters.getTrainingDays
    }
  },
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage) {
      const saleIdArr = window.location.hash.match(/\?saleId=([a-z0-9]+)/)
      if (saleIdArr instanceof Array && saleIdArr.length == 2) {
        window.localStorage.setItem('saleId', saleIdArr[1])
      }

      const result = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ window.localStorage.getItem('saleId') }`)
      if (result.data.state === 'unknown') {
        this.$router.push({ name: 'LP' })
      }
    }
  },
  components: {
    Header,
    Footer
  }
}
</script>

<style>
.table-home td {
  border: none !important;
  vertical-align: middle;
}
.lh-1 {
  line-height: 1 !important;
}
.box.is-rounded {
  border-radius: 0.5rem !important;
}
</style>




// WEBPACK FOOTER //
// src/components/Home.vue